import React from "react";
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import { TextField } from '@material-ui/core';
import moment from 'moment'
import CircularProgress from '@material-ui/core/CircularProgress'
import MuiAlert from '@material-ui/lab/Alert';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Snackbar from '@material-ui/core/Snackbar';
import { } from "pages/redux/actions";
import axios from 'axios';
import logo from 'assets/img/ld.gif';
import logo2 from 'assets/img/noimage1.jpg';
import ReactDatetime from "react-datetime";
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import Autocomplete from '@material-ui/lab/Autocomplete';
// reactstrap components
import { Button, Card, CardHeader, CardFooter, CardBody, FormGroup, Form, Modal, Input, Container, InputGroup, Row, Col, } from "reactstrap";
// core components
import UserHeader from "components/Headers/UserHeader.js";
import { makeStyles } from "@material-ui/core/styles";


const getMuiTheme = () =>
    createMuiTheme({
        overrides: {
            MuiTextField: {
                root: {
                    backgroundColor: '#fff',
                    width: '100%',
                    borderRadius: '5px',
                    border: '0px',
                    '&:hover': {
                        outline: '0',
                    },
                    '& label.Mui-focused': {
                        color: '#7c8892',
                    },
                    '& .MuiInput-underline:after': {
                        borderBottomColor: '#7c8892',
                    },
                    '& .MuiOutlinedInput-root': {
                        height: '45px',
                        '& fieldset': {
                            borderColor: '#e8ecef',
                            borderRadius: '5px',
                            border: '1px',
                            paddingTop: '0px',
                            boxShadow: '0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)',
                        },
                        '&:hover fieldset': {
                            borderColor: '#Dbe0e5',
                            border: '1px',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#',
                            border: '1px',
                            boxShadow: '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)',
                        },
                    },
                    '& .MuiInputLabel-root': {
                        fontSize: 14,
                    },
                    '& .MuiInputLabel-shrink': {
                        marginTop: '-7px',
                        marginLeft: '-13px',
                        fontSize: 16,
                        color: 'black'
                    },
                    '& .MuiFormLabel-root': {
                        color: '#a6afb7',
                        lineHeight: 0.5,
                    }
                }
            }
        },
    });

const useStyles2 = makeStyles((theme) => ({
    dark: {
        fontSize: 15,
        color: "#8898aa",
        marginTop: '1px',
        padding: '13px 12px'
    },
    white: {
        fontSize: 15,
        marginTop: '1px',
        color: "#8898aa",
        padding: '13px 12px'
    },
}));


const Profile = (props) => {
    // const location = useLocation();

    const useStyles = makeStyles((theme) => ({
        root: {
            backgroundColor: 'green',
            "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": {
                transform: "translate(14px, 20px) scale(1);",
                backgroundColor: '',
            },
            "& .MuiTextField InputLabelProps={{shrink: true}}": {
                root: {
                    backgroundColor: 'pink'
                }
            },
        },
        inputRoot: {
            color: "#a3a9b2",
            height: '42px',
            boxShadow: '0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)',
            fontSize: '15px',
            marginLeft: '0px',
            paddingTop: '15px !important',
            paddingLeft: '10px !important',
            '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
                paddingLeft: '0px !important',
                paddingTop: '0px !important',
                marginLeft: '0px',
                marginTop: '0px'
            },
            "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent"
            },
            "& .MuiTextField InputLabelProps={{shrink: true}}-root": {
            },
            "& .MuiChip-root": {
                backgroundColor: '',
                marginTop: '-15px !important',
                marginLeft: '0px !important',
                paddingTop: '0px !important',
                paddingLeft: '0px !important'
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent"
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent",
                boxShadow: '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)',
            },
            "&.MuiInputBase-inputAdornedEnd .MuiOutlinedInput-inputAdornedEnd": {
                paddingTop: '0px !important'
            }
        },
        listbox: {
            backgroundColor: 'transparent',
            marginTop: '0px',
            outline: '0',
            color: "#a3a9b2",
            borderBottom: 'none',
            paddingTop: '0px',
            paddingBottom: '0px',
        },
        paper: {
            backgroundColor: 'transparent'
        },
        clearIndicator: {
            color: "#a3a9b2",
            disableRipple: true,
        },
        popupIndicator: {
            color: "#a3a9b2",
            disableRipple: true,
        },
        option: {
            backgroundColor: (props.theme === 'white' ? '#fff' : (props.theme === 'dark' ? '#000' : '#16141f')),
            padding: '8px 8px',
            "&:hover": {
                backgroundColor: (props.theme === 'white' ? '#f5f5f5' : (props.theme === 'dark' ? '#121212' : '#201e2b'))
            },
            "&.Mui-focused": {
                backgroundColor: 'yellow'
            },
        },
        '@global': {
            '.MuiAutocomplete-option[data-focus="true"]': {
                backgroundColor: (props.theme === 'white' ? '#f5f5f5' : (props.theme === 'dark' ? '#121212' : '#201e2b'))
            }
        }
    }));
    const [sendingdata, setSendingdata] = React.useState('');
    // const [media, setmedia] = React.useState(false);
    const [tt, settt] = React.useState('');
    const [open, setOpen] = React.useState(false);
    // console.log(props)
    var con;
    if (props) {
        // console.log('yes location')
        // console.log(props);
        // console.log(props.match.params);
        if (props.match.params != null) {
            if (props.match.params.id) {
                // console.log('c')
                con = props.match.params.id
                // console.log(con)
            }
            else {
                // history.push({
                //     pathname: 'home',
                //     state: {
                //         "token": 1,
                //         "type": "error",
                //         "message": 'Something went wrong'
                //     }
                // })

            }
        }
        else {
            // history.push({
            //     pathname: 'home',
            //     state: {
            //         "token": 1,
            //         "type": "error",
            //         "message": 'Something went wrong'
            //     }
            // })
        }

    }
    else {
        // console.log('nope')
    }
    // console.log(con)
    
    const classes = useStyles();
    const classes2 = useStyles2();
    const history =useHistory();
    const ref = React.useRef()
    const [bgImage, setbgImage] = React.useState(logo);
    // const [noposter, setnoposter] = React.useState(false);
    const [responseData2, setResponseData2] = React.useState([{ id: 2, username: "ashishb", first_name: "Ashish", last_name: "Bhushan", email: "ashish.bhushan@somaiya.edu", is_staff: true, is_superuser: false }]);
    const [responseDatab, setResponseData1] = React.useState([]);
    const [tags, settags] = React.useState([{id: 2, username: "ashishb", first_name: "Ashish", last_name: "Bhushan", email: "ashish.bhushan@somaiya.edu", is_staff: true, is_superuser: false }]);
    const [event, setevent] = React.useState({"id": '', "by": '', "tags": '', "title": '', "description": '', "perks": '', "mlink": '', "rlink": '', "whatsapp": '', "target" : '', "status" : '', "poster" : '', "file" : '', "date" : '', "tfrom" : '', "tto" : '', "regfrom" : '', "regto" : '', "etype" : '', "presenter" : '', "presenterd" : '', "presenterc" : '', "presentercon" : '', "organizer" : '', "teacher1" : '', "teacher2" : '', "teacher3" : '', "student1" : '', "student2" : '', "convener1" : '', "convener2" : '', "contact1" : '', "contact2" : '', "department" : '', "certi" : '', "certion" : '', "pdate" : '', "reminders" : '', "edate": ''});
    const [editcontent, seteditcontent] = React.useState('Save');
    const [dcontent, setdcontent] = React.useState(false);
    const [calender, setcalender] = React.useState(false);
    const fetchData = React.useCallback(() => {
        // console.log('fetching')
        // console.log(location.state)
        axios.get(process.env.REACT_APP_DOMAIN+"/details/event=" + con, { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response.data)
                // console.log(Object.keys(event))
                // console.log(Object.keys(response.data))
                // console.log(response.data.regfrom)
                for (var ckey = 0; ckey < Object.keys(response.data).length; ckey++){
                    if( response.data[Object.keys(response.data)[ckey]] === null){
                        response.data[Object.keys(response.data)[ckey]] = undefined
                    }
                    // console.log(curel)
                }
                // if(noposter){
                //     console.log('')
                // }
                setevent(response.data)
                // console.log(response.data.regfrom)
                settags(response.data.tags)
                if (response.data.poster != null) {
                    var phurl = process.env.REACT_APP_DOMAIN+'' + response.data.poster;
                    // console.log(phurl)
                    setbgImage(phurl);
                }
                else {
                    setbgImage(logo2);
                    // setnoposter(true)
                }
            })
            .catch((error) => {
                setSendingdata('Something went wrong, Please Try Again')
                settt('error')
                setOpen(true);
            })
        axios.get(process.env.REACT_APP_DOMAIN + "/admins", { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response.data)
                setResponseData2(response.data)
            })
            .catch((error) => {
                setSendingdata('Something went wrong')
                settt('error')
                setOpen(true);
            })
        axios.get(process.env.REACT_APP_DOMAIN + "/events", { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                setResponseData1(response.data)
                // console.log(response.data)
                // console.log(responseDatab)
            })
            .catch((error) => {
                setSendingdata('Something went wrong')
                settt('error')
                setOpen(true)
            })
    }, [con,props.token])
    React.useEffect(() => {
        fetchData()
        document.title = "Edit Event - Depact"
    }, [fetchData])
    
    // console.log('yes')

    const handleClose = (event, reason) => {
        setOpen(false);
    };


    const dataBuyer2 = []
    if (responseDatab) {
        responseDatab.map(function (responseDatab, index) {
            var tfrom = moment(responseDatab.tfrom, "HH:mm:ss").format("hh:mm A")
            var tto = moment(responseDatab.tto, "HH:mm:ss").format("hh:mm A")
            // console.log(tfrom)
            dataBuyer2.push({
                'title': responseDatab.title, 'date': responseDatab.date, 'desc': responseDatab.description, 'time': tfrom + ' - ' + tto, 'eid': responseDatab.id
            })
            return (null)
        })
    }
    // console.log(dataBuyer2)

    const data3 = []
    if (responseData2) {
        responseData2.map(function (responseData2, index) {
            // var fullname = responseData2.first_name + ' ' + responseData2.last_name;
            // console.log(responseData2)
            data3.push(responseData2)
            return (null)
        })
    }

    const handleChange = (e) => {
        setevent({ ...event, [e.target.name]: e.target.value })
        // console.log(event)
    };

    const handleChangeED = (e) => {
        setevent({ ...event, date: moment(e._d).format("YYYY-MM-DD") })
    };

    const handleChangeTF = (e) => {
        // console.log(e._d)
        // console.log(moment(e._d).format("HH:mm:ss"))
        setevent({ ...event, tfrom: moment(e._d).format("HH:mm:ss") })
    };
    const handleChangeTT = (e) => {
        setevent({ ...event, tto: moment(e._d).format("HH:mm:ss") })
    };

    const handleCloseCal = (event) => {
        setcalender(false)
    };

    const handleChangeRF = (e) => {
        setevent({ ...event, regfrom: moment(e._d).format("YYYY-MM-DD") })
    }

    const handleChangeRT = (e) => {
        setevent({ ...event, regto: moment(e._d).format("YYYY-MM-DD") })
    }

    const handleChangeT = (e, value) => {
        // console.log(e)
        // console.log(value)
        settags(value)
        setevent({ ...event, tags: value })
    };

    const handleEventClick = (e) => {
        // console.log('yes')
        // console.log(e.event.extendedProps.eid)
        var pid = e.event.extendedProps.eid
        history.push('event/' + pid)
    }

    const handleProfilePic = () => {
        ref.current.click()
    };

    const handleProChange = (e) => {
        setbgImage(logo)
        // setpro(event.target.files[0])
        // console.log('step 1')
        let formdata = new FormData();
        // console.log(formdata)
        // console.log('step 2')
        formdata.append('file', e.target.files[0], e.target.files[0].name)
        // }
        // console.log(formdata)
        // for (var pair of formdata.entries()) {
            // console.log(pair[0] + ', ' + pair[1]);
        // }
        // console.log(formdata)
        // console.log('step 3')
        axios.post(process.env.REACT_APP_DOMAIN + '/addposter/event=' + event.id, formdata, { 'headers': { 'Authorization': 'Token ' + props.token, 'Content-type': 'multipart/form-data' } })
            .then((response) => {
                // console.log(response.data)
                // setbgImage(URL.createObjectURL(event.target.files[0]))
                setSendingdata('Poster Successfully Changed')
                settt('success')
                setOpen(true)
                // setnoposter(false)
                fetchData()
            })
            .catch((error) => {
                console.log(error)
                setOpen(true)
                setSendingdata('Something went wrong')
                settt('error')
            })
    };

    const handleChangeEdit = () => {
        if (editcontent === 'Save') {
            seteditcontent(<CircularProgress size="20px" className={"textb-" + props.theme} />)
            setdcontent(true)
            // console.log(event)
            if ((event.title === undefined) || (event.etype === undefined) || (event.date === undefined) || (event.tfrom === undefined) || (event.tto === undefined)) {
                setSendingdata('Please add main details properly')
                settt('error')
                setOpen(true)
                seteditcontent('Save')
                setdcontent(false)
                return 0;
            }
            axios.post(process.env.REACT_APP_DOMAIN + '/edit-event', event, { 'headers': { 'Authorization': 'Token ' + props.token } })
                .then((response) => {
                    // console.log(response.data)
                    seteditcontent('Save')
                    setdcontent(false)
                    setSendingdata('Event Edit Successful')
                    settt('success')
                    setOpen(true)
                    props.fetch()
                    fetchData()
                })
                .catch((error) => {
                    console.log(error)
                    seteditcontent('Save')
                    setdcontent(false)
                    setOpen(true)
                    setSendingdata('Something went wrong')
                    settt('error')
                })
        }
        else {
            seteditcontent('Save')
            setdcontent(false)
        }
    };




    return (
        <>
            <UserHeader id={props.username} />
            {/* Page content */}
            <Container className="mt--4" fluid>
                <Row>
                    <Col className="order-xl-1" xl="12">
                        <Row className="justify-content-center">
                            <Col className="order-lg-2 mt--3" lg="3">
                                <div className="card-profile-image point" style={{ zIndex: 8 }} onClick={handleProfilePic}>
                                    <img alt="..." style={{ zIndex: 9, maxWidth: '200px' }} className="rounded-circlec" src={bgImage} />
                                    <input type="file" accept="*image" ref={ref} onChange={handleProChange} style={{ display: 'none' }} />
                                </div>
                            </Col>
                        </Row>
                        <Card className={"shadow cardbg-" + props.theme}>
                            <CardHeader className={"border-0 cardbg-" + props.theme}>
                                <Row className="align-items-center">
                                    <Col xs="8">
                                        <h3 className={"mb-0 textb-" + props.theme}>Event</h3>
                                    </Col>
                                    <Col className="text-right" xs="4">
                                        <Button
                                            color="secondary"
                                            outline
                                            onClick={(e) => setcalender(!calender)}
                                        >
                                            Calender
                                        </Button>
                                    </Col>
                                </Row>
                            </CardHeader>
                            <CardBody className="pb-0">
                                <Form>


                                    <h6 className="heading-small text-muted mb-4">Main Details</h6>


                                    <div className="">
                                        <Row className="pt-3">
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Event Name" value={event.title} variant="outlined" className={"inputbg-" + props.theme} name="title" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <Input className={"form-control-alternative inputbg-" + props.theme} id="input-cno" value={event.status} name="status" onChange={handleChange} placeholder="Event Status" type="select">
                                                        <option value="c" disabled>Select Event Status</option>
                                                        <option value="Pending">Pending</option>
                                                        <option value="Confirmed">Confirmed</option>
                                                        <option value="Ongoing">Ongoing</option>
                                                        <option value="Finished">Finished</option>
                                                        <option value="Cancelled">Cancelled</option>
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <Input className={"form-control-alternative inputbg-" + props.theme} id="input-cno" value={event.etype} name="etype" onChange={handleChange} placeholder="Event Type" type="select">
                                                        <option value="c" disabled>Select Event Type</option>
                                                        <option value="Workshop">Workshop</option>
                                                        <option value="Seminar">Seminar</option>
                                                        <option value="Webinar">Webinar</option>
                                                        <option value="Competition">Competition</option>
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <Input className={"form-control-alternative inputbg-" + props.theme} value={event.target} id="input-cno" name="target" onChange={handleChange} placeholder="Event Name" type="select" >
                                                        <option value="c" disabled>Select Event Target</option>
                                                        <option value="Students">Students</option>
                                                        <option value="Faculty">Faculty</option>
                                                        <option value="All">All</option>
                                                    </Input>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <InputGroup className={"input-group-alternative inputbg-" + props.theme}>
                                                        <ReactDatetime className={"text-left inputbg-" + props.theme} name="date" timeFormat={false} value={moment(event.date).format('Do MMM YYYY')} showClearButton={true} inputProps={{ placeholder: 'Event Date', className: (event.date === undefined ? 'form-control text-red form-control-alternative inputbg-' + props.theme : 'form-control form-control-alternative inputbg-' + props.theme) }} onChange={handleChangeED} dateFormat="Do MMM YYYY" />
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <InputGroup className={"input-group-alternative inputbg-" + props.theme}>
                                                        <ReactDatetime className={"text-left inputbg-" + props.theme} name="tfrom" dateFormat={false} value={moment(event.tfrom, "HH:mm:ss").format("hh:mm A")} initialViewMode="time" inputProps={{ placeholder: 'Time From', className: (event.tfrom === undefined ? 'form-control text-red form-control-alternative inputbg-' + props.theme : 'form-control form-control-alternative inputbg-' + props.theme) }} onChange={handleChangeTF} />
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <InputGroup className={"input-group-alternative inputbg-" + props.theme}>
                                                        <ReactDatetime className={"text-left inputbg-" + props.theme} name="tto" dateFormat={false} value={moment(event.tto, "HH:mm:ss").format("hh:mm A")} initialViewMode="time" inputProps={{ placeholder: 'Time To', className: (event.tto === undefined ? 'form-control text-red form-control-alternative inputbg-' + props.theme : 'form-control form-control-alternative inputbg-' + props.theme) }} onChange={handleChangeTT} />
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>

                                    <h6 className="heading-small text-muted mb-4 mt-3">Presenter Details</h6>


                                    <div className="">
                                        <Row className="pt-3">
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Presenter Name" variant="outlined" value={event.presenter} className={"inputbg-" + props.theme} name="presenter" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Presenter Designation" variant="outlined" value={event.presenterd} className={"inputbg-" + props.theme} name="presenterd" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Presenter Company" variant="outlined" value={event.presenterc} className={"inputbg-" + props.theme} name="presenterc" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Presenter Contact" variant="outlined" value={event.presentercon} className={"inputbg-" + props.theme} name="presentercon" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>

                                    <h6 className="heading-small text-muted mb-4 mt-3">Organizer Details</h6>


                                    <div className="">
                                        <Row className="pt-3">
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Organizing Committee" variant="outlined" value={event.organizer} className={"inputbg-" + props.theme} name="organizer" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Faculty Co-ordinator" variant="outlined" value={event.teacher1} className={"inputbg-" + props.theme} name="teacher1" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Faculty Co-ordinator" variant="outlined" value={event.teacher2} className={"inputbg-" + props.theme} name="teacher2" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Faculty Co-ordinator" variant="outlined" value={event.teacher3} className={"inputbg-" + props.theme} name="teacher3" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Convener" variant="outlined" value={event.convener1} className={"inputbg-" + props.theme} name="convener1" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Convener" variant="outlined" value={event.convener2} className={"inputbg-" + props.theme} name="convener2" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Student Co-ordinator" value={event.student1} variant="outlined" className={"inputbg-" + props.theme} name="student1" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Student Co-ordinator" value={event.student2} variant="outlined" className={"inputbg-" + props.theme} name="student2" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>

                                    <h6 className="heading-small text-muted mb-4 mt-3">Registration Details</h6>


                                    <div className="">
                                        <Row className="pt-3">
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Registration Link" value={event.rlink} variant="outlined" className={"inputbg-" + props.theme} name="rlink" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <FormGroup>
                                                        <InputGroup className={"input-group-alternative inputbg-" + props.theme}>
                                                            <ReactDatetime className={"text-left inputbg-" + props.theme} name="regf" value={moment(event.regfrom).format('Do MMM YYYY')} timeFormat={false}
                                                                inputProps={{ placeholder: 'From', className: (event.regfrom === undefined ? 'form-control text-red form-control-alternative inputbg-' + props.theme : 'form-control form-control-alternative inputbg-' + props.theme) }} onChange={handleChangeRF} dateFormat="Do MMM YYYY" />
                                                        </InputGroup>
                                                    </FormGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <FormGroup>
                                                        <InputGroup className={"input-group-alternative inputbg-" + props.theme}>
                                                            <ReactDatetime className={"text-left inputbg-" + props.theme} name="regt" value={moment(event.regto).format('Do MMM YYYY')} timeFormat={false}
                                                                inputProps={{ placeholder: 'From', className: (event.regto === undefined ? 'form-control text-red form-control-alternative inputbg-' + props.theme : 'form-control form-control-alternative inputbg-' + props.theme) }} onChange={handleChangeRT} dateFormat="Do MMM YYYY" />
                                                        </InputGroup>
                                                    </FormGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Meeting Link" variant="outlined" className={"inputbg-" + props.theme} value={event.mlink} name="mlink" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>

                                    <h6 className="heading-small text-muted mb-4 mt-3">Extra Details</h6>


                                    <div className="">
                                        <Row className="pt-3">
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Event Perks" variant="outlined" className={"inputbg-" + props.theme} value={event.perks} name="perks" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField InputLabelProps={{ shrink: true }} label="Event Description" variant="outlined" className={"inputbg-" + props.theme} value={event.description} name="description" autoComplete="off" onChange={handleChange}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="6" xl="6" sm="12" md="12">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <Autocomplete
                                                            multiple
                                                            limitTags={2}
                                                            id="multiple-limit-tags"
                                                            options={data3}
                                                            classes={classes}
                                                            value={tags}
                                                            className={"inputbg-" + props.theme}
                                                            onChange={handleChangeT}
                                                            getOptionLabel={(option) => option.first_name + ' ' + option.last_name}
                                                            getOptionSelected={(option, value) => option.id === value.id}
                                                            filterSelectedOptions
                                                            renderInput={(params) => <div><TextField InputLabelProps={{ shrink: true }} {...params} label="Select Tags" style={{ height: '45px', color: '#a3a9b2', marginLeft: '0px', backgroundColor: 'transparent' }} name="tags" className="form-control-alternative" variant="outlined" /></div>}
                                                        />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                </Form>
                                <Modal
                                    size="lg"
                                    className="modal-dialog-centered pl-4 pr-4 pt-4 pb-4"
                                    isOpen={calender}
                                    toggle={handleCloseCal}>
                                    <div className="modal-header">
                                        <h2 className="modal-title mt-2 mb-0" id="modal-title-default"> Calender</h2>
                                        <button aria-label="Close" className="close" data-dismiss="modal" type="button" onClick={handleCloseCal}> <span aria-hidden={true}>×</span> </button>

                                    </div>
                                    <div className="pl-3 pr-3 pt-3 pb-3" style={{ height: '650px' }}>
                                        <FullCalendar
                                            style={{ maxHeight: '500px !important' }}
                                            plugins={[dayGridPlugin]}
                                            initialView="dayGridMonth"
                                            events={dataBuyer2}
                                            eventContent={renderEventContent}
                                            eventClick={handleEventClick}
                                        />
                                    </div>
                                </Modal>
                            </CardBody>
                            <CardFooter className={"cardbg-" + props.theme}>
                                <div className="text-center">
                                    <Button
                                        color="info"
                                        outline
                                        disabled={dcontent}
                                        onClick={handleChangeEdit}
                                    >
                                        {editcontent}
                                    </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                    <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                </Snackbar>
            </Container>
        </>
    );
};


function renderEventContent(e) {
    // console.log(e)
    // console.log(e.event.extendedProps)
    return (
        <>
            <div style={{ backgroundColor: '', border: 0 }}>
                <p className="m-0">{e.event.title}</p>
                <i>( {e.event.extendedProps.time}</i></div>
        </>
    )
}

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        theme: state.theme,
        text: state.text,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Profile);
